import {useMemo} from 'react';
import type {LinkEntityType} from 'types';
import {getLinkTargetMainAndSubTypes} from 'schemaDefinition/functions/validators';

export const useLinkTargetMainAndSubTypes = (
  type: LinkEntityType | undefined,
) => {
  return useMemo(() => getLinkTargetMainAndSubTypes(type), [type]);
};
